import { useSyncExternalStore } from 'react';

/**
 * The editor tools live inside the page's ContainerContext, the top bar lives
 * outside it. The bar registers an empty element here and the toolbar portals
 * its buttons into it, so both appear as one bar without lifting any state.
 */
let slot: HTMLElement | null = null;
const listeners = new Set<() => void>();

export const setEditBarSlot = (element: HTMLElement | null) => {
  if (slot === element) return;
  slot = element;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useEditBarSlot = (): HTMLElement | null =>
  useSyncExternalStore(subscribe, () => slot);
